import gql from 'graphql-tag';

export default gql`
  query GetStakeholderDocuments($id: String!, $billing: Boolean, $searchTerm: String, $filterTerm: DocumentStatus) {
    documents(
      orderBy: updatedAt_DESC
      where: { stakeholder: { id: $id }, billing: $billing, name_contains: $searchTerm, status: $filterTerm }
    ) {
      id
      createdAt
      updatedAt
      name
      billing
      status
      file {
        id
        original
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetStakeholderDocuments.ts